export const SUPERVISIONS_STATUS_COLORS = [
  '#A5A8D3',
  '#094452',
  '#90C4D9',
  '#EA5B1F',
  '#77AC7A',
  '#F8B238'
];

/**
 * Configuration function for set supervisions pie chart data.
 * @param {Array} supervisionsPieChartData - Data for the supervisions pie chart.
 * @param {string} total - Total number of supervisions, displayed in the center.
 * @returns {Object} - Configuration object for the supervisions pie chart.
 */
export const supervisionsPieChartConfig = (
  supervisionsPieChartData,
  total
) => ({
  appendPadding: 8,
  data: supervisionsPieChartData,
  height: 220,
  angleField: 'value',
  colorField: 'status',
  color: SUPERVISIONS_STATUS_COLORS,
  radius: 1,
  innerRadius: 0.74,
  label: false,
  legend: false,
  interactions: [
    {
      type: 'element-active'
    }
  ],
  statistic: {
    title: false,
    content: {
      offsetY: -10,
      style: { fontSize: '30px', fontWeight: 700, color: '#3F3F3F' },
      content: total
    }
  }
});
